import { Injectable } from '@angular/core';

import { AbstractEventPlugin } from './abstract.plugin';

@Injectable({
  providedIn: 'root',
})
export class StopEventPlugin extends AbstractEventPlugin {
  protected readonly modifier = '.stop';

  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  public override addEventListener(element: HTMLElement, eventName: string, handler: Function): Function {
    return this.manager.addEventListener(element, this.unwrap(eventName), (event: Event): void => {
      event.stopPropagation();
      handler(event);
    });
  }
}
